
import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
} from "@/components/ui/alert-dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { WelcomeDialogHeader } from "./WelcomeDialogHeader";
import { WelcomeDialogTabs } from "./WelcomeDialogTabs";
import { WelcomeDialogFooter } from "./WelcomeDialogFooter";
import { SermonFormData } from "@/hooks/sermon-plans/types";

interface WelcomeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activeTab: string;
  onTabChange: (value: string) => void;
  onCreateSermon: (formData?: SermonFormData) => void;
}

export function WelcomeDialog({
  open,
  onOpenChange,
  activeTab,
  onTabChange,
  onCreateSermon,
}: WelcomeDialogProps) {
  const [formData, setFormData] = useState<SermonFormData>({
    title: "",
    scripture_reference: "",
    notes: "",
    planned_date: "",
    target_duration: "30",
    sermon_type: "Expository",
    congregation_id: ""
  });

  const handleCreateSermon = () => {
    if (activeTab === 'manual') {
      onCreateSermon(formData);
    } else {
      onCreateSermon();
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-xl p-0 flex flex-col max-h-[90vh] overflow-hidden">
        <ScrollArea className="h-full max-h-[90vh] w-full overflow-auto">
          <div className="p-6 space-y-4">
            <WelcomeDialogHeader />
            
            <WelcomeDialogTabs 
              activeTab={activeTab} 
              onTabChange={onTabChange} 
              setFormData={setFormData}
            />
            
            {/* Footer is now inside the ScrollArea for better mobile experience */}
            <div className="pt-6 mt-4 border-t">
              <WelcomeDialogFooter 
                activeTab={activeTab} 
                onCreateSermon={handleCreateSermon} 
              />
            </div>
          </div>
        </ScrollArea>
      </AlertDialogContent>
    </AlertDialog>
  );
}
